export const rootElement = { id: 'root', selector: '#root' };
